import { useEffect } from 'react'
import { useLazyGetCatalog } from '../../graphQL/queries/getCatalog'
import { useAppDispatch, useAppSelector } from '..'
import {
  fetchProducts,
  fetchProductsResponse,
  fetchProductsResponseError,
} from '../../utils/fetchProducts'
import { ICatalog } from '../../graphQL/queries/getCatalog/types'
import { setFetchingMoreLoading } from '../../redux/slices/catalog'

const useFetchProducts = () => {
  const dispatch = useAppDispatch()
  const sessionId = useAppSelector(
    (state) => state.defaultSlice.sessionId || '',
  )
  const storeName = useAppSelector(
    (state) => state.defaultSlice.storeName || '',
  )
  const config = useAppSelector((state) => state.defaultSlice.config)
  const categories = useAppSelector((state) => state.catalogSlice.categories)
  const pagination = useAppSelector((state) => state.catalogSlice.pagination)
  const cartItems = useAppSelector((state) => state.cartSlice.items)
  const groups = useAppSelector((state) => state.cartSlice.groups)
  const activePromotions = useAppSelector(
    (state) => state.cartSlice.activePromotions,
  )
  const currentCategory = useAppSelector(
    (state) => state.catalogSlice.currentCategory,
  )

  useEffect(() => {
    return () => {
      dispatch(setFetchingMoreLoading(false))
    }
  }, [])

  const onCompleted = (data: ICatalog) => {
    fetchProductsResponse({
      data,
      currentCategory,
      dispatch,
      config,
      categories,
      cartItems,
      groups,
      activePromotions,
    })
  }

  const [getCatalog] = useLazyGetCatalog({
    onError: fetchProductsResponseError,
    onCompleted,
    errorPolicy: 'all',
  })

  return () => {
    fetchProducts({
      storeName,
      sessionId,
      pagination,
      currentCategory,
      dispatch,
      getCatalog,
    })
  }
}

export default useFetchProducts
